export default __webpack_public_path__ + "static/1110-ac82abaa6b311061c6b65c5b2f8edf9d.gif";